export default "__VITE_ASSET__BqUAeYJu__"